import { Dashboard } from '@mui/icons-material'
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout'
import React from 'react'
import DashboardNavbar from 'examples/Navbars/DashboardNavbar'
import VehicleCreation from './component/passwordreset'
import FilterOrg from '../OrgAmin/components/FilterOrg'
import MDBox from "components/MDBox";
import PasswordRReset from './component/passwordreset'

function PasswordReset() {
    return (
        <DashboardLayout>
            <DashboardNavbar />
            <PasswordRReset />
        </DashboardLayout>
    )
}

export default PasswordReset
